import { lazy } from 'react'
import BasicLayout from '../components/layout/BasicLayout'
import routerConstants from '../constants/routerConstants'

const routeRoleGroup: any[] = [
  { path: routerConstants.roleGroup.list, name: 'roleGroupList', exact: true, layout: BasicLayout, component: lazy(() => import('../components/admin/roleGroups/RoleGroupList')), },
  { path: routerConstants.roleGroup.add, name: 'roleGroupAdd', exact: true, layout: BasicLayout, component: lazy(() => import('../components/admin/roleGroups/RoleGroupAdd')), },
  { path: routerConstants.roleGroup.bulkChucNang, name: 'roleGroupBulkChucNang', exact: true, layout: BasicLayout, component: lazy(() => import('../components/admin/roleGroups/RoleGroupBulkChucNang')), },
  { path: routerConstants.roleGroup.edit, name: 'roleGroupEdit', exact: false, layout: BasicLayout, component: lazy(() => import('../components/admin/roleGroups/RoleGroupUpdate')), },
]
export { routeRoleGroup }